import request from '@/utils/request'

export function uploadImageAigcFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/image-aigc/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  })
}

export function deleteImageAigcUpload(uploadId) {
  return request.delete(`/image-aigc/upload/${uploadId}`)
}

export function submitImageAigc(data) {
  return request.post('/image-aigc/submit', data)
}

export function getImageAigcTasks(params) {
  return request.get('/image-aigc/tasks', { params })
}

export function getImageAigcTaskDetail(taskNo) {
  return request.get(`/image-aigc/task/${taskNo}/detail`)
}

export function getImageAigcDownloadUrl(taskNo) {
  return request.get(`/image-aigc/task/${taskNo}/download-url`)
}

export function deleteImageAigcRecord(taskNo) {
  return request.delete(`/image-aigc/tasks/${taskNo}`)
}
